const advertise = {
    dfdh: 'phone:',
    sjmc: "the shop's name",
    qsrsj: 'Please enter a business name',
    sjbzj: 'Merchant deposit',
    wcl: '30-day completion rate',
    zcd: 'Summary order (buy/sell)',
    cd: 'Order on 30th',
    c: 'Second-rate',
    fz: 'minute',
    pjfx: 'average release',
    zcsj: 'Registration time:',
    fbjy: 'To access fiat currency transactions for the first time:',
    yxbd: 'Mailbox binding',
    sjbd: 'mobile phone binding',
    cjsm: 'Primary real-name authentication',
    gjsm: 'Advanced real-name authentication',
    buy: 'Buy',
    sell: 'Sell',
    market: 'market',
    djfs: 'pricing method',
    ggid: 'Advertising ID',
    time: 'time',
    type: 'type',
    ptgg: 'general advertisement',
    gdjg: 'fixed price',
    fdjg: 'floating price',
    yjfw: 'premium range',
    unitPrice: 'unit price',
    totalPrice: 'total price',
    price: 'unit price',
    sysl: 'The remaining amount',
    ywcsl: 'Quantity completed',
    cz: 'operate',
    xj: 'Take off the shelves',
    sj: 'put on shelves',
    edit: 'edit',
    delete: 'delete',
    all: 'all',
    qdxjm: 'Are you sure you want to take down this ad?',
    qdxj: 'Delisted',
    qdsjm: 'Are you sure you want to put this ad on the shelf?',
    qdsj: 'Confirmed on the shelves',
    confirm: 'Sure',
    cancel: 'Cancel',
    qdscm: 'Are you sure you want to delete this ad?',
    deleteAdvertise: 'remove ads',

    tjgm: 'statistics purchase',
    tjcs: 'Statistics sold',
    coins: 'Currency',
    day7: '7 days',
    day15: '15 days',
    day30: '30 days',
    tj: 'statistics',
    mrsl: 'Buy quantity',
    mcsl: 'sell quantity',
    mrjj: 'average buying price',
    mcjj: 'average selling price',
    zcje: 'amount of payout',
    srje: 'income amount',
    zsxf: 'total handling fee',
    cjdd: 'Closing order',
    zdxx: 'Billing Information',
    tips: 'Tip: For each trading pair, trading statistics can only be exported 100 times a day',
    dcdd: 'export order',
    orderNo: 'order number',
    jybz: 'transaction currency',
    number: 'quantity',
    total: 'lump sum',
    fee: 'handling fee',
    zd: 'bill',

    tjskfs: 'Add payment method',
    skfs: 'payment method',
    name: 'Name',
    payAccount: 'account',
    sk: 'collect money',
    cz: 'operate',
    delete: 'delete',
    edit: 'Revise',
    qdsc: 'confirm delete?',
    tip: 'hint',
    deleted: 'Undeleted',
    xzskfstt: 'Add a payment method',
    xgskfs: 'Modify payment method',
    khmc: 'account name',
    yhkh: 'Bank card number',
    khh: 'bank',
    khhszd: 'The location of the bank',
    khhmc: 'Bank name',
    wxzh: 'WeChat account',
    zfbzf: 'Pay with Ali-Pay',
    ewmsc: 'QR code upload',
    jymm: 'transaction password',
    srkhh: 'Please enter the bank',
    xzszd: 'Please select the bank location',
    srkhmc: 'Please enter the bank name',
    srzh: 'Please input Username',
    scskm: 'Please upload the payment code',
    srjymm: 'Please enter the transaction password',
    scwjgd: 'The size of the uploaded avatar picture cannot exceed 2MB!',
    
    jnbzj1: 'As {gradeName}, you have paid a deposit of {margin} USDT, and the current remaining advertising quota is {amount} USDT',
    k: 'Can',
    add: 'append',
    or: 'or',
    reduce: 'reduce',
    margin: 'Margin',
    sqsxf: '*The platform will charge the merchant {fee}}% of the advertising turnover as a handling fee',
    hqed: 'Become a certified merchant now to get a higher limit',
    want: 'I think',
    bb: 'Currency',
    price: 'price',
    ckj: '*Market reference price {price} {fiatCurrency}/USDT fixed price will not fluctuate with the market',
    jyjg: 'Trading price',
    mdjg: 'Anchor price',
    gxhl: '*Real-time exchange rates of comprehensive banks and multiple exchanges, updated every 5 minutes',
    szyj: 'set premium',
    zjjy: '*A negative number can be entered, that is, a discounted transaction based on the anchor price',
    yjsz: '*Transaction price = anchor price * (1+premium setting)',
    jyxz: 'transaction limit',
    jysl: 'Number of transactions',
    sygged: '*The number of transactions cannot exceed the current remaining advertising quota',
    zxxe: 'Minimum single limit',
    zdxe: 'Maximum single limit',
    fkqx: 'expiration of pay',
    xnfk: '*Payment required within this time frame',
    fkfs: 'payment method',
    xzskfs: '*Up to 5 payment methods can be added for all currencies',
    yhjy: 'Do not trade with users who have not completed advanced real-name authentication',
    jygg: '*Users who have only completed primary real-name authentication cannot enter transaction advertisements',
    cyjy: 'Please select users who have not completed the specified number of purchases and cannot participate in the transaction',
    bmfx: '*Users who have completed purchases have greatly reduced the risk of unknown sources of funds',
    qxz: 'please choose',
    jybz: 'Transaction Remarks',
    tyzs: 'I understand and agree to abide by',
    jygz: '"Trading Rules"',
    yzm: 'verification code',
    save: 'save',
    fbgg: 'Place an ad',
    jsbzjcg: 'Reduce Margin Success',
    zjbzjcg: 'Successful margin call',
    xzfs: 'Please select a payment method or a payment method',
    bankTip1: 'Bank cards cannot exceed three payment methods',
    wxTip2: 'WeChat cannot exceed three payment methods',
    zfbTip3: 'Alipay cannot exceed three payment methods',
    syjg: 'Please enter a price',
    syjysl: 'Please enter the transaction quantity',
    zxxe: 'Please enter the minimum single transaction limit',
    zdxe: 'Please enter the maximum single transaction limit',
    fkqx: 'Please enter the payment period',
    tyjygz: 'Please agree to the trading rules',
    tpyzm: 'Please enter the picture verification code',
    jydx: 'Trading partners',

    zjbzj: 'margin call',
    jsbzj: 'Reduce Margin',
    xzdgged: 'The current maximum advertising quota',
    zjbzjse: 'Margin Call Amount',
    jsbzjse: 'Reduce Margin Amount',
    zjhbzjed: 'Margin Amount After Addition',
    jshbzjed: 'Margin amount after reduction',
    balance: 'balance',
    sy: 'remaining',
    kzj: 'can be appended',
    kjs: 'can be reduced',
    otcsjxy: 'OTC Merchant Service Rules Agreement',
    xsgz: 'Beginner Tutorial',
    jygz: 'Trading Rules',
    jnbzj: 'In order to ensure OTC legal compliance and standardize the behavior of all parties involved, merchants are required to pay a certain amount of deposit;',
    zjjnbzj: 'The security deposit is divided into two parts: the basic amount and the additional amount. The basic amount is a mandatory part, and the additional part is optional and may be paid or not;',
    kxs: 'Pay the basic amount to enjoy',
    fbgged: 'Publish the advertising quota of CNYT (calculated according to the exchange rate);',
    ggedbl: 'The ratio of margin to advertising quota for additional part is',
    eg: 'If an additional 100 USDT is added, the advertising quota will increase by 100 x from the basic quota',
    ggzedjs: 'The formula for calculating the total amount of advertising is: basic advertising amount + additional advertising amount x',
    ttsjzxed: 'The minimum amount of additional margin for ordinary merchants is',
    zdedw: 'The maximum amount is',
    mgsjzd: 'Each merchant can post up to three buy ads and three sell ads.',
    hljj: 'The exchange rate of USDT to CNYT is taken from the average price of relevant trading pairs on the BiKing platform in the past 24 hours (recorded once every hour, and the highest and lowest prices have been removed), as the current exchange rate value; and when the exchange rate fluctuates, the original published The advertising quota remains the same.',
    jcbzj: 'Basic Margin',
    xt: 'optional',
    njhded: 'The advertising quota you will get is:',
    mbye: 'Buy currency balance:',
    zhzcbz: 'The account assets are insufficient, you can transfer from the asset account',
    qhz: 'to transfer',
    qdjnbzj: 'Confirm payment of basic security deposit',
    tjbzj: 'add margin',
    sqsjcg: 'Apply for business successfully',
    exchange:'Currency'
  
  }
  export {
    advertise
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/advertise/en.js